import { render, staticRenderFns } from "./guideDisease.vue?vue&type=template&id=6d81eaae&scoped=true&"
import script from "./guideDisease.vue?vue&type=script&lang=js&"
export * from "./guideDisease.vue?vue&type=script&lang=js&"
import style0 from "./guideDisease.vue?vue&type=style&index=0&id=6d81eaae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d81eaae",
  null
  
)

export default component.exports